import LegendContent from './LegendContent'
import './legend.css'
import { useSelector } from 'react-redux'

//
// Does not handle the actual logic for generating the legend. Go to LegendContent.tsx for that.
//

function Legend({ colorMap, units }) {
  const darkMode = useSelector((state) => state.mapState.darkMode)

  return (
    <>
      <div className="w-56 flex flex-col text-center items-center justify-center z-[9999]">
        <LegendContent colorMap={colorMap} units={units} />
      </div>
    </>
  )
}

export default Legend
